import faq from "./faq.json";
import des from "./des.json";

export default {
    faq,
    des,
};
